import { Form, Input } from 'antd';
import type { RuleObject } from 'antd/es/form';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';
import { validateIban } from 'app/utils/iban';

import { RULES } from '../utils';

type BankAccountSectionProps = {
  isEditMode: boolean;
  hotelId: number;
};

export const BankAccountSection = ({
  isEditMode,
  hotelId,
}: BankAccountSectionProps) => {
  const { data: hotel } = useGetHotel(hotelId);

  const ibanValidator = (_: RuleObject, value: string) => {
    const isValidIban = validateIban(value);

    if (isValidIban || value.length === 0) {
      return Promise.resolve();
    }

    return Promise.reject('Must be a valid IBAN');
  };

  if (!isEditMode) {
    return (
      <>
        <FormLineLayout label="Bank">
          <span>{hotel?.finance?.bank || 'No bank specified'}</span>
        </FormLineLayout>
        <FormLineLayout label="IBAN">
          <span>{hotel?.finance?.iban || 'No IBAN specified'}</span>
        </FormLineLayout>
      </>
    );
  }

  return (
    <>
      <FormLineLayout label="Bank" isRequired>
        <Form.Item name="bank" rules={RULES}>
          <Input placeholder="Bank name" />
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="IBAN">
        <Form.Item
          name="iban"
          rules={[
            { message: 'Must be a valid IBAN', validator: ibanValidator },
          ]}
          getValueFromEvent={(e: React.ChangeEvent<HTMLInputElement>) => {
            return e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          }}
        >
          <Input placeholder="IBAN" />
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
